import { Platform } from 'react-native';
import { bgVariants } from '@/common/theme/variants';
import { tv } from 'tailwind-variants';

export const styles = {
  container: `${Platform.OS === 'web' ? 'fixed' : 'absolute'} bottom-0 left-0 right-0 top-0 z-[1] items-center justify-center overflow-hidden`,
  background: tv({
    base: 'rounded-t-xl bg-neutral20',
    variants: {
      backgroundColor: bgVariants,
    },
  }),
  footer: tv({
    base: 'pb-safe bg-neutral20',
    variants: {
      keyboardVisible: {
        true: 'pb-0',
      },
      backgroundColor: bgVariants,
    },
  }),
  view: 'h-full',
  backgroundComponent:
    'absolute bottom-0 left-0 right-0 top-0 overflow-hidden rounded-t-xl',
};
